import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { brandPayment, wholeMonthlyAmount } from 'src/services/brandPaymentService';

export default function BrandBillingSettings({ brand, onClose }) {
  const { t } = useTranslation();
  const [form, setForm] = useState(null);
  const [saved, setSaved] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let active = true;
    brandPayment
      .status(brand.brand_id)
      .then((data) => {
        if (active) {
          const value = {
            payment_enabled: data.payment_enabled,
            amount: String(data.amount),
            currency: data.currency || 'INR',
          };
          setForm(value);
          setSaved(value);
        }
      })
      .catch((e) => {
        if (active) setError(e.message);
      });
    return () => {
      active = false;
    };
  }, [brand.brand_id]);
  const dirty = JSON.stringify(form) !== JSON.stringify(saved);
  const save = async () => {
    setBusy(true);
    setError('');
    try {
      await brandPayment.save(brand.brand_id, { ...form, amount: wholeMonthlyAmount(form.amount) });
      onClose();
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onClose={busy ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('billing_payout.monthly_billing', { name: brand.brand_name })}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          {error && <Alert severity="error">{error}</Alert>}
          {form && (
            <>
              <FormControlLabel
                label={t('billing_payout.enable_monthly_payment')}
                control={
                  <Switch
                    checked={form.payment_enabled}
                    onChange={(_, checked) => setForm({ ...form, payment_enabled: checked })}
                  />
                }
              />
              <TextField
                select
                label={t('billing_payout.currency')}
                value={form.currency}
                onChange={(e) => setForm({ ...form, currency: e.target.value })}
              >
                <MenuItem value="INR">{t('billing_payout.inr_indian_rupee')}</MenuItem>
                <MenuItem value="USD">{t('billing_payout.usd_us_dollar')}</MenuItem>
              </TextField>
              <TextField
                label={t('billing_payout.monthly_amount')}
                value={form.amount}
                onChange={(e) => setForm({ ...form, amount: e.target.value })}
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
              />
              <Typography variant="body2">
                {t(
                  'billing_payout.price_changes_apply_to_new_subscriptions_disabling_billing_allows_brand_access_and_sc'
                )}
              </Typography>
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button disabled={busy} onClick={onClose}>
          {t('billing_payout.close')}
        </Button>
        <Button variant="contained" disabled={busy || !form || !dirty} onClick={save}>
          {t('billing_payout.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
